<template>
  <div id="deal-map" class="map-container">
    <client-only>
      <l-map
        :options="{
          zoomControl: true,
          scrollWheelZoom: false,
          touchZoom: false,
          dragging: false,
        }"
        :zoom-controls="false"
        style="height: 100%; width: 100%;"
        :zoom="zoom"
        :center="location"
        :bounds="bounds"
        @update:center="centerUpdated"
        @update:zoom="zoomUpdated"
        @update:bounds="boundsUpdated"
      >
        <l-tile-layer :url="mapUrl"></l-tile-layer>
        <l-marker
          v-for="position in locations"
          :key="`location-${position.lat}-${position.lng}`"
          :lat-lng="position"
          :icon="mapIcon"
        />
      </l-map>
    </client-only>
  </div>
</template>

<script>
let LMap, LTileLayer, LMarker;
let icon, latLngBounds;

if (process.client) {
  ({ icon, latLngBounds } = require('leaflet'));
  ({
    LMap,
    LTileLayer,
    LMarker,
  } = require('vue2-leaflet/dist/vue2-leaflet.min'));
}

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
  },
  props: {
    accommodations: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    mapUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    location: null,
    zoom: 10,
    bounds: null,
    minLat: 0,
    maxLat: 0,
    minLng: 0,
    maxLng: 0,
    mapIcon: null,
    locations: [],
    leaflet: null,
  }),
  mounted() {
    if (!this.accommodations.length) return;
    this.location = this.accommodations[0].hotel.location.geoCoordinate;

    this.locations = this.accommodations.map(accommodation => {
      const coordinates = accommodation.hotel.location.geoCoordinate;
      return coordinates;
    });

    if (this.locations.length > 1) {
      this.updateLocationBounds();
    }

    this.mapIcon = icon({
      iconUrl: '/assets/map-marker.svg',
      iconSize: [32, 42],
      iconAnchor: [16, 42],
    });
  },
  methods: {
    updateLocationBounds() {
      this.locations.forEach(({ lat, lng }, i) => {
        if (lat < this.minLat || this.minLat === 0) {
          this.minLat = lat;
        }
        if (lat > this.maxLat || this.maxLat === 0) {
          this.maxLat = lat;
        }
        if (lng < this.minLng || this.minLng === 0) {
          this.minLng = lng;
        }
        if (lng > this.maxLng || this.maxLng === 0) {
          this.maxLng = lng;
        }
      });
      this.bounds = latLngBounds([
        [this.minLat, this.minLng],
        [this.maxLat, this.maxLng],
      ]);
    },
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    },
  },
};
</script>

<style scoped lang="scss">
.map-container {
  width: 100%;
  height: 320px;
  overflow: hidden;
  margin: 1.5rem 0;
  border-radius: 0.5rem;
  background-color: #ededed;
  position: relative;
  z-index: 1;
}
</style>
